export const currentUser = state => state.auth.user;
